.unlinkIcon {
    height: 1.8em;
}

.tdIcon {
    cursor: pointer;
    height: 100%;
    text-align: center;
    vertical-align: middle;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}